import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { useRealtimeStatus } from '@/hooks/useRealtimeStatus';
import { cn } from '@/lib/utils';
/**
 * Banner d'avertissement quand un canal Realtime est demandé mais pas
 * encore connecté. Volontairement silencieux quand :
 *  - aucun canal n'est actif (status='idle' — home, profil, etc.)
 *  - le socket est ouvert (status='connected')
 *
 * Grace-period de 2s avant d'afficher : la plupart des connexions sont
 * établies en <500ms, on évite le flash inutile.
 */
export function RealtimeBanner() {
    const status = useRealtimeStatus();
    const [showAfterGrace, setShowAfterGrace] = useState(false);
    // Reset le grace-period si on retourne à 'connected'/'idle'.
    useEffect(() => {
        if (status !== 'connecting') {
            setShowAfterGrace(false);
            return;
        }
        const id = window.setTimeout(() => setShowAfterGrace(true), 2_000);
        return () => window.clearTimeout(id);
    }, [status]);
    if (status !== 'connecting' || !showAfterGrace)
        return null;
    return (_jsx("div", { role: "status", className: cn('sticky top-16 z-20 mx-auto max-w-7xl px-4 py-2 md:px-6', 'animate-slide-in-up'), children: _jsxs("div", { className: cn('flex items-center gap-2 rounded-2xl border px-3 py-2 backdrop-blur-md', 'border-flame-500/40 bg-flame-500/10 text-sm text-flame-100'), children: [_jsx(Loader2, { className: "h-4 w-4 animate-spin" }), _jsxs("p", { className: "flex-1", children: [_jsx("strong", { className: "font-display uppercase tracking-wider", children: "Connexion temps r\u00E9el en cours\u2026" }), _jsx("span", { className: "ml-2 text-flame-200", children: "Les notifications peuvent prendre quelques secondes. La connexion va se r\u00E9tablir." })] })] }) }));
}
